import { BaseServices } from './../../kuba.services';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { ModuleOverview } from "../models/moduleoverview";
import { ModuleOverviewServices } from '../services/module-overview.service'

@Injectable()
export class ModuleOverviewListResolver {
    constructor(private backend: ModuleOverviewServices) { }
    resolve(route: ActivatedRouteSnapshot) {
        if (BaseServices.roleId === '1') {
            let res:any = this.backend.adminModuleOverviewlist();
            return res;
        } 
    }
}

@Injectable()
export class ModuleOverviewEditResolver {
    constructor(private backend: ModuleOverviewServices) { }
    resolve(route: ActivatedRouteSnapshot) {
        return this.backend.get(+route.params['aid']);
    }
}

